"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const accessKeys_1 = require("./accessKeys");
exports.espSharedData = `
  id
  name
  displayType
  integrationType
  type
  isESP
  createdAt
  resourceUrl
  __typename
`;
exports.integrationCombinedData = graphql_tag_1.default `
  fragment integrationCombinedData on Integration {

    canConnect

    apiPublicKey
    apiSecretKey
    canConnect

    canConnect
    dataCenter

    canConnect
    accessKey {
      ...accessKeyDetailData
    }
    campaignMonitorClientName
    campaignMonitorClientId

    canConnectToREST
    canConnectToSOAP

    clientSecret
    clientSubDomain
    clientId
    accessTokenExpiryDate
    canConnectToREST
    canConnectToSOAP

    activeCampaignOrganizationSlug
    activeCampaignApiUrl
    activeCampaignWorkspaceUrl
    apiSecretKey
    integrationTimezone
  }
`;
exports.mailjetListData = graphql_tag_1.default `
  fragment mailjetListData on Mailjet {
    ... on Mailjet {
      ${exports.espSharedData}
      canConnect
    }
  }
`;
exports.activeCampaignDetailData = graphql_tag_1.default `
  fragment activeCampaignDetailData on ActiveCampaign {
    ... on ActiveCampaign {
      ${exports.espSharedData}
      canConnect
      activeCampaignOrganizationSlug
      activeCampaignApiUrl
      activeCampaignWorkspaceUrl
      apiSecretKey
      integrationTimezone
    }
  }
`;
exports.mailjetDetailData = graphql_tag_1.default `
  fragment mailjetDetailData on Mailjet {
    ... on Mailjet {
      ${exports.espSharedData}
      apiPublicKey
      apiSecretKey
      canConnect
    }
  }
`;
exports.mailchimpDetailData = graphql_tag_1.default `
  fragment mailchimpDetailData on Mailchimp {
    ... on Mailchimp {
      ${exports.espSharedData}
      canConnect
      dataCenter
      accessKey {
        ...accessKeyDetailData
      }
    }
  }
  ${accessKeys_1.accessKeyDetailData}
`;
exports.campaignMonitorDetailData = graphql_tag_1.default `
  fragment campaignMonitorDetailData on CampaignMonitor {
    ... on CampaignMonitor {
      ${exports.espSharedData}
      canConnect
      accessKey {
        ...accessKeyDetailData
      }
      campaignMonitorClientName
      campaignMonitorClientId
    }
  }
  ${accessKeys_1.accessKeyDetailData}
`;
// Not sure if the List and the detail data are needed for Sailthru
exports.sailthruListData = graphql_tag_1.default `
  fragment sailthruListData on Sailthru {
    ... on Sailthru {
      ${exports.espSharedData}
      canConnect
    }
  }
`;
exports.sailthruDetailData = graphql_tag_1.default `
  fragment sailthruDetailData on Sailthru {
    ... on Sailthru {
      ${exports.espSharedData}
      apiSecretKey
      apiPublicKey
      canConnect
    }
  }
`;
exports.salesforceListData = graphql_tag_1.default `
  fragment salesforceListData on Salesforce {
    ... on Salesforce {
      ${exports.espSharedData}
      canConnectToREST
      canConnectToSOAP
    }
  }
`;
exports.salesforceCategoryData = graphql_tag_1.default `
  fragment salesforceCategoryData on SalesforceCategory {
    ... on SalesforceCategory {
      id
      integrationId
      salesforceId
      categoryType
      name
      parentId
      enterpriseId
      memberId
      sharingProperties
      description
      allowsChildren
    }
  }
`;
exports.salesforceSendClassificationData = graphql_tag_1.default `
  fragment salesforceSendClassificationData on SalesforceSendClassification {
    ... on SalesforceSendClassification {
      id
      name
      salesforceId
    }
  }
`;
exports.salesforceDetailData = graphql_tag_1.default `
  fragment salesforceDetailData on Salesforce {
    ... on Salesforce {
      ${exports.espSharedData}
      clientSecret
      clientSubDomain
      clientId
      accessTokenExpiryDate
      canConnectToREST
      canConnectToSOAP
      useSalesforceApiVersionTwo
      salesforceAccountId
      salesforceSendClassification {
        ...salesforceSendClassificationData
      }
      salesforceOsmosysCategory {
        ...salesforceCategoryData
      }

      salesforceUserInitiatedSendsCategory {
        ...salesforceCategoryData
      }

      salesforceAssetCategory {
        ...salesforceCategoryData
      }

      salesforceContentCategory {
        ...salesforceCategoryData
      }

      salesforceSendCategory {
        ...salesforceCategoryData
      }

      salesforceTestSendCategory {
        ...salesforceCategoryData
      }
    }
  }
  ${exports.salesforceCategoryData}
  ${exports.salesforceSendClassificationData}
`;
//# sourceMappingURL=emailServiceProviders.js.map